import React from "react";
import airhomemobileicon from "./airhomemobileicon.svg";

function MobileIcon() {
  return <img src={airhomemobileicon} alt="airhomemobileicon icon " />;
}

export default MobileIcon;
